<template>
  <div>
    <Card class="mb-3">
      <template #content>
        <TrainingFilter
          v-model:selected-organization-id="selectedOrganizationId"
          v-model:selected-year="selectedYear"
          :organizations="joinedOrganizations"
          :trainings-years="trainingsYears"
          viewmode
        />
      </template>
    </Card>

    <Card>
      <template #content>
        <div class="d-flex w-100">
          <TrainingTable
            :trainings="filteredTrainings"
            class="w-100"
            @select-training="handleSelectNews"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { isSameYear } from "/@/modules/luxon";
import { useUser, useTrainings, useRouterUtil } from "/@/vue/composables";
import {
  OpenList as TrainingsList,
  Filter as TrainingFilter,
} from "/@/vue/components/Molecules/Trainings";
import { Table as TrainingTable } from "/@/vue/components/Organisms/Users/Trainings";
import { getStorage, setStorage } from "/@/modules/localStorage";
import Card from "primevue/card";

const { goto } = useRouterUtil();

const selectedOrganizationId = ref(
  getStorage("selectedOrganizationId") || undefined
);

watch(selectedOrganizationId, (id) => {
  if (!id) return;

  setStorage("selectedOrganizationId", id);
});

const selectedYear = ref(getStorage("selectedYear") || "all");
watch(selectedYear, (year) => {
  if (!year) return;

  setStorage("selectedYear", year);
});

// user

const { user } = useUser();
const joinedOrganizations = computed(() => {
  return user.value?.organizations || [];
});

watch(joinedOrganizations, (os) => {
  if (!os) return;
  if (!os.length) return;

  if (!selectedOrganizationId.value) {
    selectedOrganizationId.value = os[0].id;
  }
});

// news

const { getTrainings } = useTrainings();
const { data: trainings } = getTrainings(selectedOrganizationId);

const trainingsYears = computed(() => {
  if (!trainings.value) return [];

  return [
    "all",
    ...Array.from(new Set(trainings.value.map((n) => n.createdAt.slice(0, 4)))),
  ];
});

const filteredTrainings = computed(() => {
  if (!trainings.value) return [];
  if (!selectedOrganizationId.value) return [];

  return trainings.value.filter(
    (t) =>
      t.organizationId === selectedOrganizationId.value &&
      (selectedYear.value === "all" ||
        isSameYear(t.publishedAt, selectedYear.value))
  );
});

function handleSelectNews(id: number) {
  goto({ name: "UsersTrainingsShow", params: { id: id } });
}
</script>

<style scoped></style>
